import useApplicationData from './useApplicationData';

const useAppId = () => useApplicationData((application) => application?.app_id ?? '');

export default useAppId;
